export interface DocumentRequest {
  key: string;
  status: string;
  requestedOn: Date;
  completedOn: Date;
  errorDetails: string;
  errorType: string;
  errorDescription: string;
  requestType: string;
  expired: boolean;
  externalId: string | null;
}

export interface DocumentRequestResponse extends RequestTotals {
  requests: DocumentRequest[];
}

export interface RequestTotals {
  totalRequests: number;
  completedRequests: number;
  failedRequests: number;
}

export interface DocumentRequestQuery {
  page: number;
  pageSize: number;
  key?: string;
  externalId?: string;
  statuses?: string[];
  requestedOn?: RequestedOn;
  region?: string;
  regionUrl?: string;
}

export interface RequestedOn {
  start?: Date;
  end?: Date;
}

export interface StatusOption {
  value: string;
  label: string;
}

// Single source of truth for filterable job statuses, kept in sync with the
// backend Status enum (Portal.Data/Tables/Request.cs). Labels give the raw
// enum strings a human-readable form wherever a status is shown in the UI.
export const REQUEST_STATUSES: StatusOption[] = [
  { value: "Pending", label: "Pending" },
  { value: "Completed", label: "Completed" },
  { value: "Failed", label: "Failed" },
  { value: "AwaitingUpload", label: "Awaiting Upload" },
  { value: "UploadExpired", label: "Upload Expired" },
];

// Falls back to the raw status when it isn't recognized, so unknown/future
// backend statuses degrade gracefully instead of disappearing from the UI.
export function getStatusLabel(status: string): string {
  return REQUEST_STATUSES.find(s => s.value === status)?.label ?? status;
}
